import go from 'assets/windowsIcons/290.png';

const dropDownData = {
  File: [
    {
      type: 'item',
      text: 'Upload…',
      hotkey: 'Ctrl+U',
    },
    { type: 'separator' },
    {
      type: 'item',
      text: 'Open',
      hotkey: 'Enter',
    },
    {
      type: 'item',
      text: 'Delete',
      hotkey: 'Del',
    },
    { type: 'separator' },
    {
      type: 'item',
      text: 'Close',
      hotkey: 'Alt+F4',
    },
  ],
  Edit: [
    { type: 'item', disable: true, text: 'Undo', hotkey: 'Ctrl+Z' },
    { type: 'separator' },
    { type: 'item', disable: true, text: 'Cut', hotkey: 'Ctrl+X' },
    { type: 'item', disable: true, text: 'Copy', hotkey: 'Ctrl+C' },
    { type: 'item', disable: true, text: 'Paste', hotkey: 'Ctrl+V' },
    { type: 'separator' },
    { type: 'item', text: 'Select All', hotkey: 'Ctrl+A' },
  ],
  View: [
    { type: 'item', disable: true, text: 'Toolbars', hotkey: '' },
    { type: 'item', disable: true, text: 'Status Bar' },
    { type: 'separator' },
    { type: 'item', text: 'Refresh', hotkey: 'F5' },
  ],
  Favorites: [{ type: 'item', disable: true, text: 'Add to Favorites…' }],
  Tools: [{ type: 'item', disable: true, text: 'Folder Options…' }],
  Help: [{ type: 'item', disable: true, text: 'About My Folder' }],
};

export default dropDownData;
export { go };
